<template>

	<app-educations :cate-code="cateCode" :cate-name="cateName"></app-educations>

</template>

<script>
import AppEducations from "@/components/educations/appEducations";
export default {
	name: "el_services",
	components: {AppEducations},
	data() {

		return {
			cateCode: this.$route.params.cateCode,
			cateName: this.$route.params.cateName,
		}
	},
	created() {

	},
}
</script>

<style scoped>

</style>